import { generateResourceReducer } from '../generators/resource.reducer';

import * as types from './meeting-reports.types';
import * as constants from './meeting-reports.constants';

export const meetingReportsReducer = generateResourceReducer<types.IMeetingReport>({
  STORE: constants.STORE_MEETING_REPORT,
  CLEAR: constants.CLEAR_MEETING_REPORT,
});
